module.exports = __webpack_public_path__ + "media/img/external-link-76ce00f0557d1b1d41e8e447208ca907.svg";